import React, { useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useApi } from './ApiContext'; 
import toast from 'react-hot-toast'; // Pakai toast abang untuk alert cun
import './Signup.css';

const Signup = () => {
    const { API_BASE_URL } = useApi();
    
    // API Endpoints
    const REQUEST_SIGNUP_API = `${API_BASE_URL}/signup/request`;
    // const VERIFY_SIGNUP_API = `${API_BASE_URL}/signup/verify`; /* COMMENTED: OTP tidak lagi digunakan */

    // Form States
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    // const [otp, setOtp] = useState(''); /* COMMENTED */

    // Flow States
    const [step, setStep] = useState(1); 
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    // ➡️ FASA 1: Hantar maklumat untuk daftar terus
    const handleSignupRequest = async (e) => {
        e.preventDefault();
        
        if (!username.trim() || !email.trim() || !password.trim() || !confirmPassword.trim()) {
            setError('Please fill in all fields');
            return;
        }

        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        if (!API_BASE_URL) {
            setError('Configuration error. API URL is missing.');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await axios.post(REQUEST_SIGNUP_API, { 
                username: username.trim(),
                email: email.trim(),
                password: password.trim()
            });

            if (response.data.success) {
                toast.success('Account created successfully! Please login.');
                history.push('/login'); // Terus ke login page
            } else {
                setError(response.data.message || 'Signup failed');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Signup request failed');
        } finally {
            setLoading(false);
        }
    };

    /* 
    // ➡️ FASA 2: Hantar OTP (COMMENTED OUT)
    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        // ... (kod asal di-comment supaya tidak aktif)
    };
    */

    return (
        <div className="base-signup">
            <div className="signup-container">
                <h2>Sign Up</h2>
                {error && <p className="error">{error}</p>}
                
                {/* STEP 1: ISI BORANG PENDAFTARAN */}
                {step === 1 && (
                    <form onSubmit={handleSignupRequest}>
                        <div className="form-group">
                            <label htmlFor="username">Username</label>
                            <input
                                type="text"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                disabled={loading}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={loading}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                disabled={loading}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="confirmPassword">Confirm Password</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                disabled={loading}
                                required
                            />
                        </div>
                        <button className="signup-button" type="submit" disabled={loading}>
                            {loading ? 'Processing...' : 'Sign Up'}
                        </button>
                    </form>
                )}

                {/* 
                // STEP 2: MASUKKAN VERIFICATION CODE (COMMENTED OUT)
                {step === 2 && (
                   ...
                )} 
                */}
                
                <p className="auth-switch">
                    Already have an account?{' '}
                    <span onClick={() => history.push('/login')}> Login</span>
                </p>
            </div>
        </div>
    );
};

export default Signup;